import http from '../http';

// 获取预结算信息
const fetchPreSettleInfo = (params) => {
  return http({
    url: `bill/pre/detail/${params.resvNo}`,
  });
};

const fetchV2PreSettleInfo = (params) => {
  return http({
    url: `bill/v2/pre/detail/${params.resvNo}`,
  });
};

export { fetchPreSettleInfo, fetchV2PreSettleInfo };
